<template>
  <AppDialog
    title="Copy your access token"
    size="smedium"
    :show="show"
    append-to-body
    data-testid="api-token-secret-dialog"
    @close="$emit('close')"
  >
    <p class="text-muted">
      This is the only time the token secret will be shown. Copy it now and store it securely —
      you won't be able to see it again.
    </p>

    <div
      class="d-flex align-items-center"
      style="gap: 8px"
    >
      <AppInput
        :value="secret"
        type="text"
        readonly
        class="flex-1"
        data-testid="api-token-secret-value"
        @click="selectAll"
      />
      <AppButton
        type="primary"
        data-testid="api-token-copy"
        @click="copy"
      >Copy</AppButton>
    </div>
  </AppDialog>
</template>

<script>
export default {
  name: 'ApiTokenSecretDialog',
  props: {
    show: { type: Boolean, default: false },
    secret: { type: String, default: '' },
  },
  methods: {
    async copy() {
      if (await this.copyToClipboard(this.secret)) {
        this.$appMessage?.('Token copied to clipboard');
      } else {
        this.$appMessage?.('Could not copy — select the token and copy it manually');
      }
    },
    // Prefer the async Clipboard API; fall back to execCommand for non-secure contexts (http dev).
    async copyToClipboard(text) {
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(text);

          return true;
        } catch (e) {
          // fall through to the execCommand fallback
        }
      }

      const textarea = document.createElement('textarea');

      try {
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-1000px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        return document.execCommand('copy');
      } catch (e) {
        return false;
      } finally {
        // Always remove the node so the secret never lingers in the DOM, even on error.
        textarea.remove();
      }
    },
    selectAll(event) {
      event?.target?.select?.();
    },
  },
};
</script>
